import { render, staticRenderFns } from "./ZusatzbausteinePrivat.vue?vue&type=template&id=640ea4ce&"
import script from "./ZusatzbausteinePrivat.vue?vue&type=script&lang=js&"
export * from "./ZusatzbausteinePrivat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports